import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-cell',
  template: `
    <ng-content></ng-content>
  `,
  styleUrls: ['./cell.component.scss'],
  host: {
    '[class.indicator]': 'indicator',
    '[class.header]': 'header',
    '[class.title]': 'title',
    '[class.main]': 'main',
    '[class.border-top]': 'borderTop',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CellComponent {
  @Input() indicator?: boolean;
  @Input() header?: boolean;
  @Input() title?: boolean;
  @Input() main?: boolean;
  @Input() borderTop?: boolean;
}
